import { useNavigate } from 'react-router-dom';
import NavbarNoProfile from '../components/NavbarNoProfile.js';
import LoadingWheel from '../components/LoadingWheel.js';
import { API_BASE } from '../../helper_methods/api.js';

export default function ProfileLoading() {
        
    //USENAVIGATE HOOK
    let navigate = useNavigate();

    fetch(`${API_BASE}/profile`, {
        method: 'get',
        credentials: 'include'
    })
    .then(response => response.json())
    .then(response => {
        if (response.message) {
            navigate(`/profile/${response.userid}`)
        } else {
            navigate('/signin')
        }
    })
    .catch(error => {
        navigate('/signin')
    })

    return (
       <>
            <LoadingWheel />

            <div className="profile-bg"></div>

            <NavbarNoProfile/>
        </>
    );
}